import { reactive, ref } from 'vue'
import { useApi } from '@/functions/api'

export const ROLE = {
  ANGGOTA: 'anggota',
  CALON_ANGGOTA: 'calon anggota',
}

export const PERMISSION = {
  ACCESS_ADMIN: 'mengakses halaman admin',

  ANNOUNCEMENT_LIST: 'melihat list pengumuman',
  ANNOUNCEMENT_SHOW: 'melihat detail pengumuman',
  ANNOUNCEMENT_CREATE: 'menambah pengumuman',
  ANNOUNCEMENT_EDIT: 'mengedit pengumuman',
  ANNOUNCEMENT_DELETE: 'menghapus pengumuman',

  ROLE_LIST: 'melihat halaman list peran',
  ROLE_LIST_FOR_FILTER_USER: 'melihat list peran',
  ROLE_SHOW: 'melihat detail peran',
  ROLE_CREATE: 'menambah peran',
  ROLE_EDIT: 'mengedit peran',
  ROLE_DELETE: 'menghapus peran',

  USER_LIST: 'melihat list pengguna',
  USER_SHOW: 'melihat detail pengguna',
  USER_CREATE: 'menambah pengguna',
  USER_EDIT: 'mengedit pengguna',
  USER_DELETE: 'menonaktifkan pengguna',
  USER_RESTORE: 'mengaktifkan pengguna',
  USER_BANK: 'mengelola bank pengguna',
  USER_EXPORT_EXCEL: 'mendownload excel pengguna',
  USER_MANAGE_PLAVON: 'mengelola plavon pengguna',
  USER_SHOW_SAVINGS_AMOUNT: 'melihat jumlah simpanan pengguna',
  USER_EDIT_PASSWORD: 'mengedit password pengguna',
  USER_EDIT_AVATAR: 'mengedit avatar pengguna',
  USER_OFFBOARD: 'melihat form mengundurkan diri / keluar / pindah',
  USER_MANAGE_SAVING_TYPE: 'mengelola tipe simpanan pengguna',
  USER_IMPORT: 'mengimpor pengguna',
  NOTIFICATION_USER_IMPORTED: '(admin) menerima notifikasi pengguna hasil impor',

  SUPPLIER_LIST: 'melihat list supplier',
  SUPPLIER_SHOW: 'melihat detail supplier',
  SUPPLIER_CREATE: 'menambah supplier',
  SUPPLIER_EDIT: 'mengedit supplier',
  SUPPLIER_DELETE: 'menonaktifkan supplier',
  SUPPLIER_RESTORE: 'mengaktifkan supplier',
  SUPPLIER_EXPORT_EXCEL: 'mendownload excel supplier',

  SUPPLIER_CONTACT_CREATE: 'menambah kontak supplier',
  SUPPLIER_CONTACT_EDIT: 'mengedit kontak supplier',
  SUPPLIER_CONTACT_DELETE: 'menghapus kontak supplier',

  SUPPLIER_BANK_CREATE: 'menambah bank supplier',
  SUPPLIER_BANK_EDIT: 'mengedit bank supplier',
  SUPPLIER_BANK_DELETE: 'menghapus bank supplier',

  PRODUCT_CATEGORY_LIST: 'melihat list kategori produk',
  PRODUCT_CATEGORY_SHOW: 'melihat detail kategori produk',
  PRODUCT_CATEGORY_CREATE: 'menambah kategori produk',
  PRODUCT_CATEGORY_EDIT: 'mengedit kategori produk',
  PRODUCT_CATEGORY_DELETE: 'menonaktifkan kategori produk',
  PRODUCT_CATEGORY_RESTORE: 'mengaktifkan kategori produk',

  PRODUCT_LIST: 'melihat list produk',
  PRODUCT_SHOW: 'melihat detail produk',
  PRODUCT_SET_BARCODE: 'mengatur barcode produk',
  PRODUCT_CREATE: 'menambah produk',
  PRODUCT_EDIT: 'mengedit produk',
  PRODUCT_DELETE: 'menonaktifkan produk',
  PRODUCT_RESTORE: 'mengaktifkan produk',
  PRODUCT_EXPORT_EXCEL: 'mendownload excel produk',

  PRODUCT_STOCK_MONTHLY_EXPORT: 'mendownload excel penilaian akhir stok bulanan',

  PRODUCT_STOCKOPNAME_LIST: 'melihat list stock opname produk',
  PRODUCT_STOCKOPNAME_CREATE: 'menambah stock opname produk',
  PRODUCT_STOCKOPNAME_SHOW: 'melihat detail stock opname produk',
  PRODUCT_STOCKOPNAME_DELETE: 'menghapus stock opname produk',
  PRODUCT_STOCKOPNAME_EXCEL: 'mendownload excel stock opname produk',

  PRODUCT_EXPIRATION_LIST: 'melihat list produk kadaluarsa',
  PRODUCT_EXPIRATION_CREATE: 'menambah produk kadaluarsa',
  PRODUCT_EXPIRATION_EDIT: 'mengedit produk kadaluarsa',
  PRODUCT_EXPIRATION_DELETE: 'menghapus produk kadaluarsa',
  PRODUCT_EXPIRATION_EXPORT_EXCEL: 'mendownload excel produk kadaluarsa',

  PRODUCT_DAMAGE_LIST: 'melihat list kerusakan produk',
  PRODUCT_DAMAGE_CREATE: 'menambah kerusakan produk',
  PRODUCT_DAMAGE_SHOW: 'melihat detail kerusakan produk',
  PRODUCT_DAMAGE_DELETE: 'menghapus kerusakan produk',
  PRODUCT_DAMAGE_EXPORT_EXCEL: 'mendownload excel kerusakan produk',

  PURCHASE_LIST: 'melihat list pembelian',
  PURCHASE_SHOW: 'melihat detail pembelian',
  PURCHASE_CREATE: 'menambah pembelian',
  PURCHASE_EDIT: 'mengedit pembelian',
  PURCHASE_DELETE: 'membatalkan pembelian',
  PURCHASE_RESTORE: 'mengaktifkan pembelian',
  PURCHASE_EXPORT_EXCEL: 'mendownload excel pembelian',

  PURCHASE_PAYMENT_LIST: 'melihat list pembayaran pembelian',
  PURCHASE_PAYMENT_SHOW: 'melihat detail pembayaran pembelian',
  PURCHASE_PAYMENT_CREATE: 'menambah pembayaran pembelian',
  PURCHASE_PAYMENT_DELETE: 'membatalkan pembayaran pembelian',

  SALE_LIST: 'melihat list penjualan',
  SALE_SHOW: 'melihat detail penjualan',
  USER_SHOW_LOANS_AMOUNT: 'melihat jumlah pinjaman pengguna',
  SALE_CREATE: 'menambah penjualan',
  SALE_DELETE: 'membatalkan penjualan',
  SALE_RESTORE: 'mengaktifkan penjualan',
  SALE_CREATE_SELF: 'menambah penjualan (sendiri)',
  SALE_EXPORT_EXCEL: 'mendownload excel penjualan',
  SALE_IMPORT: 'mengimpor penjualan',

  SALE_PROCESS_STORE: 'memproses penjualan',
  SALE_PROCESS_DESTROY: 'membatalkan proses penjualan',

  PAYMENT_METHOD_LIST: 'melihat list metode pembayaran',
  PAYMENT_METHOD_CREATE: 'menambah metode pembayaran',
  PAYMENT_METHOD_EDIT: 'mengedit metode pembayaran',
  PAYMENT_METHOD_DELETE: 'menonaktifkan metode pembayaran',
  PAYMENT_METHOD_RESTORE: 'mengaktifkan metode pembayaran',

  SAVING_LIST: 'melihat list simpanan',
  SAVING_IN_CREATE: 'menambah setoran simpanan',
  SAVING_OUT_CREATE: 'menambah penarikan simpanan',
  SAVING_IN_DELETE: 'menghapus setoran simpanan',
  SAVING_OUT_DELETE: 'menghapus penarikan simpanan',
  SAVING_EXPORT_EXCEL_RECAP: 'mendownload excel rekap simpanan',
  SAVING_WITHDRAWAL_REJECT: 'menolak penarikan simpanan',
  SAVING_WITHDRAWAL_REJECT_DESTROY: 'membatalkan penolakan penarikan simpanan',
  SAVING_WITHDRAWAL_STORE: 'meverifikasi penarikan simpanan',
  SAVING_WITHDRAWAL_DESTROY: 'membatalkan verifikasi penarikan simpanan',
  SAVING_IMPORT: 'mengimpor simpanan',

  SAVING_TYPE_CREATE: 'menambah tipe simpanan',
  SAVING_TYPE_EDIT: 'mengedit tipe simpanan',
  SAVING_TYPE_DELETE: 'menghapus tipe simpanan',
  SAVING_TYPE_EXPORT_EXCEL: 'mendownload excel tipe simpanan',
  SAVING_TYPE_ENTRY_EXPORT_EXCEL: 'mendownload excel laporan setoran tipe simpanan',

  LOAN_TYPE_CREATE: 'menambah tipe pinjaman',
  LOAN_TYPE_EDIT: 'mengedit tipe pinjaman',
  LOAN_TYPE_DELETE: 'menghapus tipe pinjaman',
  LOAN_TYPE_EXPORT_DAILY_REPORT: 'mengexport laporan harian tipe pinjaman',
  LOAN_TYPE_EXPORT_RECAP_LOANS: 'mengexport pinjaman berdasarkan tipe pinjaman',

  LOAN_LIST: 'melihat list pinjaman',
  LOAN_SHOW: 'melihat detail pinjaman',
  LOAN_CREATE: 'menambah pinjaman',
  LOAN_CREATE_SELF: 'menambah pinjaman (sendiri)',
  LOAN_EDIT: 'mengedit pinjaman',
  LOAN_DELETE: 'membatalkan pinjaman',
  LOAN_IMPORT: 'mengimpor pinjaman',

  LOAN_APPROVE: 'menyetujui pinjaman',
  LOAN_APPROVE_CANCEL: 'membatalkan persetujuan pinjaman',

  LOAN_REJECT: 'menolak pinjaman',
  LOAN_REJECT_CANCEL: 'membatalkan penolakan pinjaman',

  LOAN_PAYMENT_LIST: 'melihat list pembayaran pinjaman',
  LOAN_PAYMENT_SHOW: 'melihat detail pembayaran pinjaman',
  LOAN_PAYMENT_CREATE: 'menambah pembayaran pinjaman',
  LOAN_PAYMENT_CREATE_SALARY_ATTACHMENT: 'menambah pembayaran pinjaman (pemotongan gaji)',
  LOAN_PAYMENT_PAY_OFF: 'melunasi pinjaman (langsung lunas)',
  LOAN_PAYMENT_DELETE: 'membatalkan pembayaran pinjaman',

  LOAN_TOPUP_LIST: 'melihat list topup pinjaman',
  LOAN_TOPUP_SHOW: 'melihat detail topup pinjaman',
  LOAN_TOPUP_CREATE: 'menambah topup pinjaman',
  LOAN_TOPUP_CREATE_SELF: 'menambah topup pinjaman (sendiri)',
  LOAN_TOPUP_APPROVE: 'menyetujui topup pinjaman',
  LOAN_TOPUP_APPROVE_CANCEL: 'membatalkan persetujuan topup pinjaman',
  LOAN_TOPUP_REJECT: 'menolak topup pinjaman',
  LOAN_TOPUP_REJECT_CANCEL: 'membatalkan penolakan topup pinjaman',

  SALARY_DEDUCTION_LIST: 'melihat list potongan gaji',
  SALARY_DEDUCTION_EXPORT: 'mendownload excel potongan gaji',

  SALARY_DEDUCTION_APPROVE: 'menyetujui potongan gaji',
  SALARY_DEDUCTION_APPROVE_BULK: 'menyetujui beberapa potongan gaji',
  SALARY_DEDUCTION_APPROVE_CANCEL: 'membatalkan persetujuan potongan gaji',
  SALARY_DEDUCTION_REJECT: 'menolak potongan gaji',
  SALARY_DEDUCTION_REJECT_CANCEL: 'membatalkan penolakan potongan gaji',

  SYSTEM_SETTING_EDIT: 'mengedit pengaturan sistem',

  NOTIFICATION_SALE_CREATED: '(admin) menerima notifikasi penjualan baru',
  NOTIFICATION_SALE_PROCESSED: '(admin) menerima notifikasi penjualan diproses',
  NOTIFICATION_PURCHASE_BUY_PAYMENT: '(admin) menerima notifikasi pembayaran pembelian',
  NOTIFICATION_PURCHASE_RETUR_PAYMENT: '(admin) menerima notifikasi pembayaran retur pembelian',
  NOTIFICATION_LOAN_CREATED: '(admin) menerima notifikasi pinjaman baru',
  NOTIFICATION_LOAN_APPROVED: '(admin) menerima notifikasi persetujuan pinjaman',
  NOTIFICATION_LOAN_REJECTED: '(admin) menerima notifikasi penolakan pinjaman',
  NOTIFICATION_SAVING_CREATED: '(admin) menerima notifikasi simpanan baru',
  NOTIFICATION_SALE_IMPORTED: '(admin) menerima notifikasi penjualan hasil impor',
  NOTIFICATION_LOAN_IMPORTED: '(admin) menerima notifikasi pinjaman hasil impor',
  NOTIFICATION_SAVING_IMPORTED: '(admin) menerima notifikasi simpanan hasil impor',
  NOTIFICATION_LOAN_TOPUP_CREATED: '(admin) menerima notifikasi topup pinjaman baru',
  NOTIFICATION_LOAN_TOPUP_APPROVED: '(admin) menerima notifikasi persetujuan topup pinjaman',
  NOTIFICATION_LOAN_TOPUP_APPROVE_CANCELLED: '(admin) menerima notifikasi pembatalan persetujuan topup pinjaman',
  NOTIFICATION_LOAN_TOPUP_REJECTED: '(admin) menerima notifikasi penolakan topup pinjaman',
  NOTIFICATION_LOAN_TOPUP_REJECT_CANCELLED: '(admin) menerima notifikasi pembatalan penolakan topup pinjaman',

  // Audit Logs
  AUDIT_LOG_LIST: 'melihat list audit log',
}

export function useRoleGetList () {
  const api = useApi()
  const loading = ref(false)
  const roles = ref<Role[]>([])
  const permissions = ref<Permission[]>([])

  const getData = async (apiParams?: object) => {
    loading.value = true
    try {
      const response = await api.GET<ResponseRolePermission>('role', apiParams)
      roles.value = response.roles
      permissions.value = response.permission_tree
    } finally {
      loading.value = false
    }
  }

  const roleCreated = (data: Role) => {
    roles.value.push(data)
  }
  const roleEdited = (data: Role) => {
    const findByIndex = roles.value.findIndex(role => role.id === data.id)
    roles.value[findByIndex].name = data.name
  }
  const roleDeleted = (id: number) => {
    const index = roles.value.findIndex(role => role.id === id)
    roles.value.splice(index, 1)
  }
  const permissionEdited = (data: RolePermissionEdited) => {
    const findByIndex = roles.value.findIndex(role => role.id === data.id)
    roles.value[findByIndex].permissions = data.permissions
  }

  return {
    loading,
    permissions,
    roles,
    getData,
    roleCreated,
    roleEdited,
    roleDeleted,
    permissionEdited,
  }
}

export function useRoleCreate () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})
  const form = reactive({
    name: '',
  })

  const resetForm = () => {
    form.name = ''
    errors.value = {}
  }

  const submit = async () => {
    submitting.value = true
    try {
      const response = await api.POST<Role>('role', form)
      return response
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    submitting,
    errors,
    form,
    resetForm,
    submit,
  }
}

export function useRoleEdit () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})
  const form = reactive({
    name: '',
  })
  const role = ref<Role>()

  const resetForm = (data: Role) => {
    form.name = data.name
    errors.value = {}
    role.value = data
  }

  const submit = async () => {
    submitting.value = true
    try {
      const response = await api.PUT<Role>(`role/${role.value!.id}`, form)
      return response
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    submitting,
    errors,
    form,
    resetForm,
    submit,
  }
}

export function useRoleDelete () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})
  const role = ref<Role>()

  const resetForm = (data: Role) => {
    errors.value = {}
    role.value = data
  }

  const submit = async () => {
    submitting.value = true
    try {
      await api.DELETE(`role/${role.value!.id}`)
      return true
    } catch (error) {
      errors.value = api.formErrors(error)
      return false
    } finally {
      submitting.value = false
    }
  }

  return {
    submitting,
    errors,
    role,
    resetForm,
    submit,
  }
}

export function useRoleTogglePermission () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})

  const submit = async (roleId: number, permission: string) => {
    submitting.value = true
    try {
      const response = await api.PUT<RolePermissionEdited>(`role/${roleId}/toggle-permission`, {
        name: permission,
      })
      return response
    } catch (error) {
      errors.value = api.formErrors(error)
    } finally {
      submitting.value = false
    }
  }

  return {
    submitting,
    errors,
    submit,
  }
}
